import React from 'react'
import { Trans } from 'react-i18next'
import clsx from 'clsx'

import { Check16 } from '@makyoapp/makyo-icon/icon'

interface ChangeSavedProps {
  defaultClassName?: boolean
  className?: string
  /**
   * is currently saving
   */
  isSaving: boolean

  isSaved: boolean
}
export function ChangeSaved({ defaultClassName = true, className, isSaving, isSaved }: ChangeSavedProps) {
  return isSaved ? (
    <div className={clsx(defaultClassName && 'text-primary-500 font-medium flex-c', className)}>
      <Check16 />
      <div>
        <Trans>Changes saved!</Trans>
      </div>
    </div>
  ) : isSaving ? (
    <div className={clsx(className, 'flex-c')}>
      <span className='loading spin' />
      <div>
        <Trans>Saving!</Trans>
      </div>
    </div>
  ) : null
}
